import type { ReactNode } from "react";

import { cn } from "@/utils/cn";

import { type AlphaStep, AlphaStepper } from "./AlphaStepper";

type AlphaStepLayoutProps = {
  actions?: ReactNode;
  activeStep: AlphaStep;
  children: ReactNode;
  className?: string;
  footer?: ReactNode;
};

export function AlphaStepLayout({
  actions,
  activeStep,
  children,
  className,
  footer,
}: AlphaStepLayoutProps) {
  return (
    <div
      className={cn(
        "flex flex-col rounded-2xl border border-border-secondary bg-bg-primary [view-transition-name:alpha-card]",
        className,
      )}
    >
      <div className="flex items-center justify-between gap-lg border-b border-border-secondary px-xl py-xl lg:px-3xl">
        <AlphaStepper activeStep={activeStep} />
        {actions && <div className="flex items-center gap-md">{actions}</div>}
      </div>
      <div className="flex min-h-0 flex-1 flex-col [view-transition-name:alpha-step-body]">
        {children}
      </div>
      {footer && (
        <div className="flex items-center justify-between gap-lg border-t border-border-secondary px-xl py-xl lg:px-3xl">
          {footer}
        </div>
      )}
    </div>
  );
}
